export enum CRMModalID {
    CRMModalDetails,
    CRMScopeDetails,
    CRMConfigurationDetails
}
